import {FC, useEffect} from 'react'
import {Navigate, useNavigate} from 'react-router-dom'
import {savePendingConnect, takePendingConnect} from '../modules/channels/pendingConnect'

// Deslogado abriu /connect/...: guarda o destino (com o fragmento do código) e manda para o login.
const SaveConnectAndLogin: FC = () => {
  savePendingConnect(window.location.pathname + window.location.hash)
  return <Navigate to='/auth' replace />
}

// Recém-logado: retoma o destino guardado, ou vai para o dashboard.
const PostLoginRedirect: FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(takePendingConnect() || '/dashboard', {replace: true})
  }, [navigate])

  return null
}

export {SaveConnectAndLogin, PostLoginRedirect}
